module.exports = __webpack_public_path__ + "static/img/process-28.fc10621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/process-28.jpg
// module id = BP+g
// module chunks = 0